<template>
    <v-container fluid fill-height>
        <v-layout align-left justify-start>
            <v-flex xs12 sm10 md8 lg6>
                <!-- page title -->
                <div class="mb-2">
                    <h1 class="page__title">История действий</h1>
                </div>

                <!-- page table -->
                <v-data-iterator
                    v-bind:items="items"
                    v-bind:rows-per-page-items="rowsPerPageItems"
                    v-bind:rows-per-page-text="'записей на странице'"
                    v-bind:pagination.sync="pagination"
                    v-bind:no-data-text="'записи не найдены'"
                    select-all
                    row
                    wrap
                >
                    <v-flex slot="item" slot-scope="props">
                        <v-list class="elevation-5 mb-2" dense>
                            <v-list-tile>
                                <v-list-tile-content
                                    class="card__paragraph pr-1"
                                    >{{ props.item.name }}</v-list-tile-content
                                >

                                <v-list-tile-content
                                    class="align-center subheading brown_6--text pr-1"
                                    >{{
                                        props.item.description
                                    }}</v-list-tile-content
                                >

                                <v-list-tile-content
                                    class="align-end subheading brown_6--text"
                                    >{{ props.item.date }}</v-list-tile-content
                                >
                            </v-list-tile>
                        </v-list>
                    </v-flex>
                </v-data-iterator>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data: () => ({
        rowsPerPageItems: [4, 8, 12, { text: 'все', value: -1 }],
        pagination: {
            rowsPerPage: 4,
        },
        items: [
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
                fat: 0.2,
                carbs: 98,
                protein: 0,
                sodium: 38,
                calcium: '0%',
                iron: '2%',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
            {
                value: false,
                name: 'Заголовок действия',
                description: 'Описание действия',
                date: 'чт, 20 апреля 2017, 10:54',
            },
        ],
    }),
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
.history {
    font-size: 16px;

    &__marker {
        border-radius: 50%;
        height: 10px;
        width: 10px;
        background-color: #db8484;
    }
}
</style>
